const notificationsGuard = (to, from, next) => {
  const tipoUsuario = localStorage.getItem("tipo usuario");
  console.log("tipoUsuario", tipoUsuario);

  const rolesPermitidos = [
    "Notificante",
    "Notificante - Departamental",
    "Super User",
    "User Tester",
  ];

  if (rolesPermitidos.includes(tipoUsuario)) {
    next();
  } else {
    next("/acceso-denegado");
  }
};

export default notificationsGuard;
